// extracted by mini-css-extract-plugin
module.exports = {"content":"payment-error_content__1VVLK","block":"payment-error_block__2yKoT","description":"payment-error_description__3yyp3"};